import React, { memo } from 'react';
import './style.css';

const Button = ({
  className = '',
  onClick = null,
  children = 'Button Text',
  type = 'primary',
  size = 'md',
  disabled = false,
  location = '',
  hidden = false,
}) => (
  <button
    type="button"
    className={`btn btn-${
      disabled ? 'disabled' : type
    } btn-${size} btn-${location} ${className}`}
    onClick={onClick}
    disabled={disabled}
    hidden={hidden}
  >
    {children}
  </button>
);

export default memo(Button);
